import { mergeAttributes, Node, nodeInputRule } from '@tiptap/core';
import { VueNodeViewRenderer } from '@tiptap/vue-3';
import EditorImage from 'shared/components/EditorImage.vue';
import { uploadImagePlugin } from 'shared/components/upload-image';

export const inputRegex = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/;

export default ({ uploadFn, hasStorage, imageTypes, eventBus }) => Node.create({
  name: 'image',

  addOptions() {
    return {
      inline: false,
      HTMLAttributes: {},
    };
  },

  inline() {
    return false;
  },

  atom: true,
  selectable: true,

  group() {
    return 'block';
  },

  draggable: true,

  addAttributes() {
    return {
      src: { default: null },
      alt: { default: null },
      name: { default: null },
      size: { default: null },
      autoOpen: { default: null },
      image: { default: null },
      uploader: { default: null },
    };
  },
  parseHTML: () => [
    {
      tag: 'img[src]',
      getAttrs: (dom) => {
        if (typeof dom === 'string') return {};
        const element = dom;

        return {
          src: element.getAttribute('src'),
          alt: 'new image',
          name: 'new image',
        };
      },
    },
  ],
  renderHTML: ({ HTMLAttributes }) => [
    'img',
    mergeAttributes(HTMLAttributes),
  ],

  addNodeView() {
    return VueNodeViewRenderer(EditorImage);
  },

  addCommands() {
    return {
      setImage:
          (attrs) => ({ state, dispatch }) => {
            const { selection } = state;
            const position = selection.$head
              ? selection.$head.pos
              : selection.$to.pos;

            const node = this.type.create(attrs);
            const transaction = state.tr.insert(position, node);
            return dispatch(transaction);
          },
    };
  },
  addInputRules() {
    return [
      nodeInputRule({
        find: inputRegex,
        type: this.type,
        getAttributes: (match) => {
          const [, , alt, src, title] = match;
          return {
            src,
            alt,
            title,
          };
        },
      }),
    ];
  },
  addProseMirrorPlugins() {
    return [uploadImagePlugin(uploadFn, hasStorage, imageTypes, eventBus)];
  },
});
